import { render, staticRenderFns } from "./add_categories_page.vue?vue&type=template&id=497e5890"
import script from "./add_categories_page.vue?vue&type=script&lang=js"
export * from "./add_categories_page.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports